import AboutMe from "../../Components/AboutMe";
import Header from "../../Components/Header";
import ParticlesComponent from "../../Components/particles";

const PageAboutMe = () => {
  return (
    <>
      <ParticlesComponent />;
      <Header />
      <AboutMe />
    </>
  );
};
export default PageAboutMe;
